import React from 'react'
import { SocietyLayout } from '../../../SocietyLayout'
import { SocietyManagementTicketSideBarContent } from './SocietyManagementTicketSideBarContent'

export const SocietyManagementTicketLayout = (): React.ReactNode => {
  return (
    <SocietyLayout
      noContainer
      sidebar={<SocietyManagementTicketSideBarContent />}
    />
  )
}
